import { tokenManager } from "utils/tokenManager";

const API_BASE = "https://usibras-web-backend.onrender.com/api";

/** Cache TTL: 2 minutes - data is considered fresh for this duration */
const CACHE_TTL_MS = 2 * 60 * 1000;
let cache = { data: null, timestamp: 0 };

function isCacheValid() {
  return cache.data !== null && Date.now() - cache.timestamp < CACHE_TTL_MS;
}

/**
 * Clear the RCN deliveries cache. Call after create/update/delete
 * so the next fetch will hit the API.
 */
export function invalidateRcnDeliveriesCache() {
  cache = { data: null, timestamp: 0 };
}

/**
 * Fetch RCN deliveries. Uses cache if valid unless forceRefresh is true.
 * @param {boolean} [forceRefresh=false] - If true, bypass cache and always hit API
 * @returns {Promise<Array>} List of RCN delivery records
 */
export async function fetchRcnDeliveries(forceRefresh = false) {
  if (!forceRefresh && isCacheValid()) {
    return cache.data;
  }

  const authHeader = tokenManager.getAuthHeader();
  if (!authHeader) {
    throw new Error("Authentication required");
  }

  const resp = await fetch(`${API_BASE}/rcn-deliveries`, {
    headers: { Authorization: authHeader },
  });
  const result = await resp.json().catch(() => ({}));

  if (!resp.ok) {
    throw new Error(result.message || result.error || "Failed to load");
  }

  const data = result.data || [];
  cache = { data, timestamp: Date.now() };
  return data;
}
